import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoader:false,
  allBrands:[],
}

export const brandSlice = createSlice({
  name: 'allBrand',
  initialState,
  reducers: {
    getBrandStart: (state,action) => {
        state.isLoader= true
    },
    getBrandSuccess: (state,action) => {
        state.isLoader= false
        state.allBrands = action.payload
    },
    deleteBrand:(state,action) => {
      state.isLoader = true
      state.allBrands = state.allBrands.filter((elem)=>elem._id !== action.payload)
      state.isLoader = false

    },
    updateBrand: (state,action) => {
      const Index = state.allBrands.findIndex(brand => brand._id === action.payload._id);
      if(Index !== -1 ){
        state.allBrands[Index] = action.payload;
      }
    }
  },
})

export const {getBrandStart, getBrandSuccess, deleteBrand, updateBrand} = brandSlice.actions

export default brandSlice.reducer